// @ts-ignore
export const isSafari = window.ApplePaySession;